module.exports = __webpack_public_path__ + "static/media/blog-category1.3887d4d6.png";